import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { featureList } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="scroll-mt-section bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="核心功能"
            title="围绕观看流程的六项能力"
            subtitle="从找到内容、稳定播放，到跨端继续观看与互动整理，下面六项能力覆盖了日常使用的主要环节。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featureList.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 80}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 transition-colors hover:border-primary-300">
                <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-2xl">
                  <i className={feature.icon} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}